export const itemCodeText = (product) => Array.isArray(product.item_codes)
  ? product.item_codes.map(String).filter(Boolean).join(", ")
  : typeof product.item_codes === "string" ? product.item_codes.trim() : "";

export const verifiedGroupDimensions = (product) => product.source_specs_verified === true && typeof product.dimensions === "string"
  ? product.dimensions.trim()
  : "";
